const locale = require('./detailedHistory.i18n.json');

/*@ngInject*/
const historyGridController = function ($controller, $rootScope, $scope, coreMediator, coreConstant, landingConstant, submissionGridConstant, submissionConstant) {

    angular.extend(this, $controller('baseGridWidgetController', {$scope: $scope}));

    this.$onInit = function () {
        this.onInit();

        this.i18n = locale;
        $scope.viewModel = {showPaging: true};
        $scope.recordCountText = _.get(locale, 'historyCount');

        this.isGenericItem = true;
        this.isUserTypeUpdated = true;

        this.requestParams = {
            key: 'type',
            pageSize: 20,
            startIndex: 0,
            sortType: 'asc',
            criteriaName: 'default'
        };
        this.initLandingPage();
    };

    this.onPagingChange = function ($event, params) {
        this.startIndex = params.startIndex;
        $scope.$parent.viewModel.requestParams.startIndex = params.startIndex;
        this.loadGrid();
    };

    this.updateFilterFromPreferences = function () {
        $scope.$broadcast(submissionGridConstant.event.RESET_GRID_LIST);
    };

    this.loadRecords = function (onSuccess, onError) {
        this.parent.loadRecords(onSuccess, onError);
    };

    this.generateColumns = function () {
        this.colViewModel = this.gridModel.getGridColumns();
        this.dropdownColumns = this.gridModel.getDropdownColumns();
    };

    $scope.$on(submissionConstant.event.HISTORY_FILTER_CHANGE, function (event) {
        this.resetGridPaging();
    }.bind(this));

    $scope.resetGridHeaders = function (requestParams) {
        this.parent.resetGridHeaders(requestParams);
    }.bind(this);

    $scope.$on(submissionGridConstant.event.RESET_GRID_COLUMNS, function () {
        this.resetGridColumns();
    }.bind(this));
};

angular.module('gw-um-submission')
    .controller('historyGridController', historyGridController);
